import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateServiceSchema, generateWebPageSchema } from '../../utils/seo';

export default function Prestations() {
  // SEO Configuration
  useSEO({
    title: 'PRT Propreté - Nos Prestations',
    description: 'Découvrez nos prestations de lavage automobile premium avec PRT Propreté. Profitez de notre Pack Premium à 60€ ou du Pack Luxe à 80€ pour un nettoyage intérieur et extérieur de qualité professionnelle. Déplacement gratuit dans un rayon de 35 km autour de Creil. Cliquez pour voir toutes nos prestations et choisir le service adapté à votre véhicule.',
    keywords: 'lavage auto Creil, préparateur auto, nettoyage voiture, detailing auto, lavage intérieur, lavage extérieur, Creil 60',
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        generateServiceSchema(),
        generateWebPageSchema('Nos Prestations - PRT Propreté', 'Découvrez nos formules de lavage professionnel')
      ]
    }
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a1a3e] via-[#2d2d6e] to-[#4a4aaa]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12 md:pb-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
            Nos Prestations
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-2">
            Découvrez nos formules de lavage professionnel adaptées à tous vos besoins
          </p>
        </div>
      </section>

      {/* Packs Section */}
      <section className="py-10 sm:py-12 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 md:gap-12 mb-12 sm:mb-16 md:mb-20">
            {/* Pack Premium */}
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 hover:bg-white/10 transition-all duration-300">
              <div className="text-center mb-6 sm:mb-8">
                <div className="inline-block px-4 sm:px-6 py-2 bg-cyan-400/20 rounded-full text-cyan-400 font-bold mb-3 sm:mb-4 text-sm sm:text-base">
                  Formule Complète
                </div>
                <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-cyan-400 mb-2 sm:mb-3">60€</div>
                <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">Pack Premium</h2>
                <p className="text-gray-300 text-sm sm:text-base">Nettoyage intérieur complet</p>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8 md:mb-10">
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage moquette</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">En profondeur</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage des tapis</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">Tapis comme neufs</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage plastiques</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">Tableau de bord</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Shampouinage sièges</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">Propres et désinfectés</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage vitres</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">Vitres impeccables</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Entourage portes</h3>
                    <p className="text-gray-400 text-xs sm:text-sm">Joints propres</p>
                  </div>
                </div>
              </div>
              
              <Link 
                to="/contact" 
                className="whitespace-nowrap w-full block text-center px-6 sm:px-8 py-4 sm:py-5 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-full text-base sm:text-lg font-bold hover:bg-white/20 transition-all duration-300 cursor-pointer"
              >
                Réserver cette formule
              </Link>
            </div>

            {/* Pack Luxe */}
            <div className="bg-gradient-to-br from-cyan-400/20 to-blue-500/20 backdrop-blur-md border-2 border-cyan-400/50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 relative overflow-hidden">
              <div className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-cyan-400 text-[#1a1a3e] px-3 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-base font-bold shadow-lg">
                <i className="ri-star-fill mr-1 sm:mr-2"></i>
                Le Plus Complet
              </div>
              
              <div className="text-center mb-6 sm:mb-8 pt-8 sm:pt-0">
                <div className="inline-block px-4 sm:px-6 py-2 bg-cyan-400/30 rounded-full text-cyan-400 font-bold mb-3 sm:mb-4 text-sm sm:text-base">
                  Formule Premium
                </div>
                <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-cyan-400 mb-2 sm:mb-3">80€</div>
                <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">Pack Luxe</h2>
                <p className="text-gray-300 text-sm sm:text-base">Nettoyage intérieur + extérieur complet</p>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8 md:mb-10">
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage moquette</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">En profondeur</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage des tapis</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Tapis comme neufs</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage plastiques</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Tableau de bord</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Shampouinage sièges</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Propres et désinfectés</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage vitres</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Intérieures et extérieures</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white/10 rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <i className="ri-check-double-line text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Entourage portes</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Joints propres</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-cyan-400/20 rounded-lg sm:rounded-xl p-3 sm:p-4 border border-cyan-400/30">
                  <i className="ri-star-fill text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-bold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage extérieur</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Carrosserie brillante</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-cyan-400/20 rounded-lg sm:rounded-xl p-3 sm:p-4 border border-cyan-400/30">
                  <i className="ri-star-fill text-cyan-400 text-xl sm:text-2xl mr-3 sm:mr-4 mt-0.5 sm:mt-1"></i>
                  <div>
                    <h3 className="text-white font-bold mb-0.5 sm:mb-1 text-sm sm:text-base">Nettoyage jantes</h3>
                    <p className="text-gray-300 text-xs sm:text-sm">Jantes éclatantes</p>
                  </div>
                </div>
              </div>
              
              <Link 
                to="/contact" 
                className="whitespace-nowrap w-full block text-center px-6 sm:px-8 py-4 sm:py-5 bg-cyan-400 text-[#1a1a3e] rounded-full text-base sm:text-lg font-bold hover:bg-cyan-300 transition-all duration-300 shadow-lg hover:shadow-cyan-400/50 cursor-pointer"
              >
                Réserver cette formule
              </Link>
            </div>
          </div>

          {/* Suppléments Section */}
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10">
            <div className="text-center mb-6 sm:mb-8 md:mb-10">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-4">Suppléments</h2>
              <p className="text-base sm:text-lg md:text-xl text-gray-300">Options additionnelles pour personnaliser votre prestation</p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-5xl mx-auto">
              <div className="bg-white/5 rounded-xl sm:rounded-2xl p-4 sm:p-6 text-center hover:bg-white/10 transition-all duration-300">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-bear-smile-line text-2xl sm:text-3xl text-cyan-400"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Poils d'animaux</h3>
                <div className="text-2xl sm:text-3xl font-bold text-cyan-400 mb-1 sm:mb-2">20€</div>
                <p className="text-gray-400 text-xs sm:text-sm">Élimination complète des poils</p>
              </div>
              
              <div className="bg-white/5 rounded-xl sm:rounded-2xl p-4 sm:p-6 text-center hover:bg-white/10 transition-all duration-300">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-user-smile-line text-2xl sm:text-3xl text-cyan-400"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Sièges enfants</h3>
                <div className="text-2xl sm:text-3xl font-bold text-cyan-400 mb-1 sm:mb-2">15€</div>
                <p className="text-gray-400 text-xs sm:text-sm">Nettoyage des sièges enfants</p>
              </div>
              
              <div className="bg-white/5 rounded-xl sm:rounded-2xl p-4 sm:p-6 text-center hover:bg-white/10 transition-all duration-300">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-car-line text-2xl sm:text-3xl text-cyan-400"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Véhicules très sales</h3>
                <div className="text-2xl sm:text-3xl font-bold text-cyan-400 mb-1 sm:mb-2">20€</div>
                <p className="text-gray-400 text-xs sm:text-sm">Supplément pour état très sale</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Informations Section */}
      <section className="py-10 sm:py-12 md:py-16 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-6 sm:mb-8 md:mb-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-4">Informations Importantes</h2>
          </div>
          
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-cyan-400/30 rounded-xl sm:rounded-2xl p-4 sm:p-6 flex items-start">
              <i className="ri-information-line text-cyan-400 text-2xl sm:text-3xl mr-3 sm:mr-4 mt-0.5 sm:mt-1 flex-shrink-0"></i>
              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-1 sm:mb-2">Véhicule vide requis</h3>
                <p className="text-gray-300 text-sm sm:text-base">Votre véhicule doit être vide avant la prestation pour garantir un nettoyage optimal.</p>
              </div>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-cyan-400/30 rounded-xl sm:rounded-2xl p-4 sm:p-6 flex items-start">
              <i className="ri-flashlight-line text-cyan-400 text-2xl sm:text-3xl mr-3 sm:mr-4 mt-0.5 sm:mt-1 flex-shrink-0"></i>
              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-1 sm:mb-2">Accès à l'électricité</h3>
                <p className="text-gray-300 text-sm sm:text-base">Un accès à l'électricité est nécessaire pour nos équipements professionnels.</p>
              </div>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-cyan-400/30 rounded-xl sm:rounded-2xl p-4 sm:p-6 flex items-start">
              <i className="ri-drop-line text-cyan-400 text-2xl sm:text-3xl mr-3 sm:mr-4 mt-0.5 sm:mt-1 flex-shrink-0"></i>
              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-1 sm:mb-2">Arrivée d'eau pour nettoyage extérieur</h3>
                <p className="text-gray-300 text-sm sm:text-base">Une arrivée d'eau est nécessaire pour les prestations incluant le nettoyage extérieur.</p>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-cyan-400/20 to-blue-500/20 backdrop-blur-md border-2 border-cyan-400/50 rounded-xl sm:rounded-2xl p-4 sm:p-6 flex items-start">
              <i className="ri-map-pin-line text-cyan-400 text-2xl sm:text-3xl mr-3 sm:mr-4 mt-0.5 sm:mt-1 flex-shrink-0"></i>
              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-1 sm:mb-2">Déplacement gratuit</h3>
                <p className="text-gray-300 text-sm sm:text-base">Nous nous déplaçons gratuitement dans un rayon de 35kms autour de Creil (60).</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Prêt à Réserver Votre Prestation ?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-6 sm:mb-8 md:mb-10 px-2">
            Contactez-nous pour choisir la formule qui vous convient
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-cyan-400 text-[#1a1a3e] rounded-full text-base sm:text-lg font-bold hover:bg-cyan-300 transition-all duration-300 shadow-lg hover:shadow-cyan-400/50 hover:scale-105 cursor-pointer"
            >
              Demander un devis
            </Link>
            <a 
              href="tel:0776969414" 
              className="whitespace-nowrap w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-full text-base sm:text-lg font-bold hover:bg-white/20 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              07.76.96.94.14
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
